angular.module('app.general').filter('normalizeText', normalizeTextFilter);

/**
 * https://stackoverflow.com/questions/990904/remove-accents-diacritics-in-a-string-in-javascript
 */
function normalizeTextFilter() {
  return (str: string) => str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
}
